export enum ConnectionModal {
  AddConnection = "addConnection",
  AddManagedConnection = "addManagedConnection",
  ChangeOwner = "changeOwner",
  Delete = "delete",
  Reconnect = "reconnect",
  Replace = "replace",
  Rename = "rename",
  Share = "share",
}

export enum ConnectionShareType {
  Owner = "owner",
  Group = "group",
  Member = "member",
  All = "all",
}

/**
 * Payload for the onConnectionError callback that carries a failed connection
 * attempt up from AddConnectionModal to the App Connections page, where it's
 * interpreted (ER-530). errorDescription is the raw string from ConnectApp's
 * connectionError postMessage.
 */
export interface ConnectionErrorCallbackPayload {
  appId: string;
  errorDescription?: string;
}
